import React from "react";

const ContactDrawerSkeleton = () => (
  <div className="flex flex-col gap-3 p-4 overflow-y-auto bg-slate-50 dark:bg-slate-800/30 animate-pulse">
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-5 flex flex-col items-center gap-3">
      <div className="w-24 h-24 rounded-full bg-slate-200 dark:bg-slate-700" />
      <div className="h-4 w-28 bg-slate-200 dark:bg-slate-700 rounded" />
      <div className="h-4 w-24 bg-slate-200 dark:bg-slate-700 rounded" />
      <div className="h-8 w-32 bg-slate-200 dark:bg-slate-700 rounded-lg" />
    </div>
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4 space-y-3">
      {[1, 2, 3].map((i) => (
        <div key={i} className="rounded-lg bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 space-y-1.5">
          <div className="h-3 w-16 bg-slate-200 dark:bg-slate-700 rounded" />
          <div className="h-3 w-32 bg-slate-200 dark:bg-slate-700 rounded" />
        </div>
      ))}
    </div>
  </div>
);

export default ContactDrawerSkeleton;
